"use strict";var t=require("../String/stringPadStart.cjs");exports.formatMessageCode=function(r,a,n){var c=t.stringPadStart(a.toString(),2,"0"),i=t.stringPadStart(n.toString(),3,"0");return"".concat(r,"-").concat(c).concat(i)};
//# sourceMappingURL=formatMessageCode.cjs.map
